import { useState } from "react";
import { useDispatch } from "react-redux";
import { actions } from "store/actions";
import authApi from "api/auth";
import { useNavigate } from "react-router-dom";

function useLogout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const onLogoutSubmit = async () => {
    try {
      setIsLoading(true);
      await authApi.logout();
      dispatch(actions.resetUser());
      navigate("/login");
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };
  return { onLogoutSubmit, isLoading };
}

export default useLogout;
